import React from 'react';
import ViewDashboards from './ViewDashboards';

/**
 * Public shared dashboard — same layout/widgets as the owner's view.
 * Route param :token is read by ViewDashboards (public share mode).
 */
const SharedDashboardView = () => <ViewDashboards />;

export default SharedDashboardView;
